import ConnectionAnswerItem from './ConnectionAnswerItem';

export default ConnectionAnswerItem;
